import { func, shape, arrayOf, string, instanceOf } from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  materialPropType,
  materialWithCountPropType,
  copperSpecPropType 
} from '../../../lib/shapes';
import { Material } from '../../../models';

export const propTypes = {
  addLayer:      func.isRequired,
  copper:        shape(copperSpecPropType).isRequired,
  core:          shape(materialPropType).isRequired,
  prepreg:       shape(materialWithCountPropType).isRequired,
  stackupLayers: arrayOf(instanceOf(Material)).isRequired,
  stackupType:   string.isRequired,
  lengthUnit:    string.isRequired,

  /* with-router */
  history: ReactRouterPropTypes.history.isRequired,
};

export default propTypes;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/AddLayer/propTypes.js